import { render, staticRenderFns } from "./PersonAttendanceStatic.vue?vue&type=template&id=6256d01d&scoped=true"
import script from "./PersonAttendanceStatic.vue?vue&type=script&lang=js"
export * from "./PersonAttendanceStatic.vue?vue&type=script&lang=js"
import style0 from "./PersonAttendanceStatic.vue?vue&type=style&index=0&id=6256d01d&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6256d01d",
  null
  
)

export default component.exports